<div class='row'>
  <div class="col-md-8">
    <app-carousel [data]="newlastrace"></app-carousel>
    <app-adventure [data]="newlastrace"></app-adventure>
  </div>
  <div class="col-md-4">
    <div>
      <h4>
        Your Activitys
        <span style="float: right">
          <app-newactivity></app-newactivity>
        </span>
      </h4>
    </div>
    <div>
      <app-activity></app-activity>
    </div>
  </div>
</div>




